import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { SlowConnectionService } from '../services/slow-connection/slow-connection.service';

/**
 * Reports every (non-static) request's lifetime to the SlowConnectionService so
 * it can surface a "slow connection" state when requests hang.
 *
 * Registered this BEFORE the AuthInterceptor so it wraps the whole logical
 * request — including any token-refresh retry — as a single tracked operation.
 */
@Injectable()
export class SlowConnectionInterceptor implements HttpInterceptor {
  private readonly slowConnection = inject(SlowConnectionService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isStaticAsset(req.url)) {
      return next.handle(req);
    }

    this.slowConnection.requestStarted();

    return next.handle(req).pipe(finalize(() => this.slowConnection.requestEnded()));
  }

  private isStaticAsset(url: string): boolean {
    const staticAssetPattern = /\.(svg|png|jpg|jpeg|gif|ico|css|js|woff2?|ttf|eot|json)$/i;
    return url.startsWith('assets/') || staticAssetPattern.test(url);
  }
}
